<template>
  <div>
    <v-row v-if="preview">

      <!-- Recogida de datos -->
      <v-col cols="12">
        <v-row justify="space-around">
          <v-col cols="10" class="headline font-weight-bold">
            1. Recogida de datos
          </v-col>
          <v-col cols="7">
            <data-collect :preview="preview" />
          </v-col>
        </v-row>
      </v-col>
      
      <!-- Resumen -->
      <v-col cols="12" >
        <v-row justify="space-around">
          <v-col cols="10" class="headline font-weight-bold">
            2. Resumen
          </v-col>
          <v-col cols="9">
            <data-resume :preview="preview" :blades="blades" />
          </v-col>
        </v-row>
      </v-col>

      <!-- Palas -->
      <v-col cols="12" v-for="(blade, i) in blades" :key="blade.id">
        <v-row justify="space-around">
          
          <v-col cols="10" class="headline font-weight-bold">
            {{ parseInt(i + 3) }}. Pala {{ blade }} - {{ preview.wind_blade_serial_numbers[blade] }}
          </v-col>

          <!-- Daños -->
          <v-col cols="12" v-for="(damage, idx) in preview.blades[blade].damages" :key="damage.id">
            <v-row align="center" justify="space-around">

              <!-- Daño -->
              <v-col cols="9" class="headline font-weight-bold">
                {{ parseInt(i + 3) + '.' + parseInt(idx + 1) }}. Daño {{ parseInt(idx + 1) }}
              </v-col>

              <!-- Datos del daño -->
              <v-col cols="9">
                <v-row justify="space-around">

                  <v-col cols="12">
                    {{ parseInt(i + 3) + '.' + parseInt(idx + 1) }}.1. Datos del daño
                  </v-col>

                  <v-col cols="10">
                    <data-damage inspection :damage="damage" />
                  </v-col>

                </v-row>
              </v-col>

              <!-- Posición del daño -->
              <v-col cols="9">
                <v-row justify="space-around">

                  <v-col cols="12">
                    {{ parseInt(i + 3) + '.' + parseInt(idx + 1) }}.2. Posición del daño
                  </v-col>

                  <v-col cols="10">
                    <blade-damage-vp :damageZones="damage.damage_zones"/>
                  </v-col>

                  <v-col cols="10">                           
                    <division />
                  </v-col>

                  <v-col cols="10">
                    <blade-damage-vs :damageZones="damage.damage_zones"/>
                  </v-col>

                </v-row>
              </v-col>

              <!-- Fotos -->
              <v-col cols="9">
                <v-row justify="space-around">

                  <v-col cols="12">
                    {{ parseInt(i + 3) + '.' + parseInt(idx + 1) }}.3. Fotos del daño
                  </v-col>

                  <v-col cols="10">
                    <v-row justify="space-around">

                      <v-col cols="12">
                        <v-row justify="space-around">
                          <!-- :cols="gridSize['inspection']" -->
                          <v-col
                            v-for="item in damage['inspection_images']"
                            :key="item.id"
                            :cols="damage['inspection_images'].length > 1 ? 6 : 12"
                            class="text-center"
                          >
                            <v-card flat tile class="grey elevation-0">
                              <v-img :src="item.download_url" contain>
                                <template v-slot:placeholder>
                                  <v-row class="fill-height ma-0 grey lighten-5" align="center" justify="center" >
                                    <v-progress-circular indeterminate color="grey"/>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>

                    </v-row>
                  </v-col>

                </v-row>
              </v-col>

            </v-row>
          </v-col>

          <!-- Panoramica -->
          <v-col cols="12">
            <v-row align="center" justify="space-around">

              <v-col cols="9" class="headline font-weight-bold">
                {{ parseInt(i + 3) + '.' + parseInt(preview.blades[blade].damages.length + 1) }}. Panorámicas de pala
              </v-col>

              <v-col cols="9">
                <v-row justify="space-around">
                  <v-col cols="10">
                    <v-row justify="space-around">
                      <!-- :cols="gridSize['panoramic']" -->
                      <v-col
                        v-for="item in preview.blades[blade].panoramic_images"
                        :key="item.id"
                        :cols="preview.blades[blade].panoramic_images.length > 1 ? 6 : 12"
                        class="text-center"
                      >
                        <v-card class="grey">
                          <v-img :src="item.download_url" contain></v-img>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>

            </v-row>
          </v-col>

        </v-row>
      </v-col>

      <!-- Registro de cambios -->
      <v-col cols="12">
        <v-row justify="space-around">
          <v-col cols="10" class="headline font-weight-bold">
           {{ parseInt(blades.length) + 3 }}. Registro de cambios
          </v-col>
          <v-col cols="8">
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr class="font-weight-bold">
                    <td width="15%" class="border-black-left-start text-center">Rev.</td>
                    <td width="30%" class="border-black-right-start text-center">Fecha</td>
                    <td width="55%" class="border-black-right-start">Descripción</td>
                  </tr>
                  <tr v-for="item in preview.version_control" :key="item.id">
                    <td width="15%" class="border-black-left text-center">{{ item.version_number }}</td>
                    <td width="30%" class="border-black-right text-center">{{ formatDate(item.report_date) }}</td>
                    <td width="55%" class="border-black-right">{{ item.report_description }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-col>

    </v-row>
  </div>
</template>

<script>
import BladeDamageVP from "@/components/InterventionReview/Damage/BladeDamage/VP";
import BladeDamageVS from "@/components/InterventionReview/Damage/BladeDamage/VS";
import Division from "@/components/InterventionReview/Damage/BladeDamage/Division";
import DataCollect from "./DataCollect";
import DataResume from "./DataResume";
import DataDamage from "./DataDamage";
import Util from "@/util/index";

export default {
  props: {
    preview: { type: Object, default: null },
  },
  components: {
    'blade-damage-vp': BladeDamageVP,
    'blade-damage-vs': BladeDamageVS,
    Division,
    DataCollect,
    DataResume,
    DataDamage
  },
  computed: {
    loading: {
      get () {
        return this.$store.state.loading
      },
      set (val) {
        this.$store.commit('loading', val)
      }
    },
    gridSize () {
      return this.$store.state.reports.gridSize
    },
    blades () {
      return this.preview && this.preview.blades 
        ? Object.keys(this.preview.blades)
        : []
    },
  },
  methods: {
    formatDate(date) {
      return Util.formatDate(date)
    },
  },
}
</script>
